import React, { useState } from "react";

const DynamicModal = ({ show, onHide, modalContent, onConfirm }) => {
  const [comment, setComment] = useState("");
  const [reason, setReason] = useState("");

  return (
    <div
      className={`modal ${show ? "show" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(1px)",
      }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div
          className="modal-content"
          style={{ borderRadius: 12, boxShadow: "0 0 9px rgba(0, 0, 0, 0.4)" }}
        >
          <div className="modal-header border-0">
            <div className="row w-100">
              <div className="col-12 d-flex justify-content-center">
                {modalContent.icon && (
                  <img src={modalContent.icon} alt="Icon" style={{ width: 50, height: 50 }} />
                )}
              </div>
              <h5 className="col-12 modal-title d-flex justify-content-center">{modalContent.head}</h5>
            </div>
            {/* <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true">&times;</span>
            </button> */}
          </div>
          <div className="modal-body d-flex justify-content-center">
            {modalContent.body === "reason" ? (
              <>
                <label>Select reason for rejection</label>
                <select
                  className="form-control"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Select Reason"
                >
                  <option value="">Select Reason</option>
                  <option value="reason1">Reason 1</option>
                  <option value="reason2">Reason 2</option>
                  <option value="reason3">Reason 3</option>
                </select>
                <label>Add Comment</label>
                <textarea
                  className="form-control"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Add Comment"
                />
              </>
            ) : modalContent.body === "content" ? (
                <p className="text-dark d-flex justify-content-center text-center">{modalContent.content}</p>
            ) : (
              <textarea
                className="form-control"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Add Comment"
              />
            )}
          </div>
          <div className="modal-footer border-0">
            {modalContent.showCancel && (
              <button
                type="button"
                className="btn w-100 btn-light text-dark border"
                onClick={onHide}
              >
                Cancel
              </button>
            )}
            <button
              type="button"
              className={`btn w-100 ${
                modalContent.footer === "Reject" ? "btn-danger" : "btn-primary"
              }`}
              onClick={() => {
                onConfirm(); // Call the onConfirm function from props
                onHide(); // Hide the modal after confirmation
              }}
            >
              {modalContent.footer}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicModal;
